import routerOptions0 from "/home/vsts/work/1/s/node_modules/.pnpm/nuxt@3.17.5_@azure+identity@4.13.0_@parcel+watcher@2.5.1_@types+node@24.0.3_better-sqli_c8f50053b4ed4e2aa8d97bbf32f28d79/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/vsts/work/1/s/apps/lobby/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}